import { render, staticRenderFns } from "./Material.vue?vue&type=template&id=8f7768c6&scoped=true&"
import script from "./Material.vue?vue&type=script&lang=js&"
export * from "./Material.vue?vue&type=script&lang=js&"
import style0 from "./Material.vue?vue&type=style&index=0&id=8f7768c6&scoped=true&lang=css&"
import style1 from "./Material.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7768c6",
  null
  
)

export default component.exports